<template>
  <i :class="`fa-solid fa-${style.ico} fa-2x ${style.color}`"></i>
</template>
<script>
export default {
  name: "iconIndustries",
  props: {
    type: String,
  },
  data() {
    return {
      title: "iconIndustries",
    };
  },
  computed: {
    style() {
      let style = {
        ico: "circle",
        color: "has-text-danger",
      };
      if (this.type === "✔️") {
        style.ico = "circle-check";
        style.color = "has-text-success";
      } else {
        style.ico = "ban";
        style.color = "has-text-grey";
      }
      return style;
    },
  },
};
</script>
